<script setup>
import {onMounted, provide, ref} from "vue";
import PostComposition, {USE_POST_KEY} from "./PostComposition";
const siteUrl = document.querySelector('meta[name="site-url"]').content;

//id 重複回避のためのランダム文字列を生成
const uniqueIdPrefix = 'u-'+Math.random().toString(36).slice(-16)+'-';

//コンポジションを定義、配信
const composition = PostComposition();
provide(USE_POST_KEY, composition);

//表示フラグ
const showModal = ref(false);

//モーダルを表示した際のスクロール量
const scrollTop = ref(0);

//キャンペーンカテゴリ/タグの名称
const _campaignTagCategoryName = ref('');
const _campaignTagTagName = ref('');

//ニックネーム選択肢の表示・非表示
const showNicknameSelect = ref(false);

//ニックネーム新規追加欄の表示・非表示
const showNicknameAppend = ref(false);

//二重送信を防ぐためのタイマー
const showNicknameAppendTimer = ref(0);

//新規追加するニックネーム
const nicknameAppend = ref('');

//新規追加するニックネームに対するエラー
const nicknameAppendErrors = ref([]);

//確認画面かどうか
const isConfirm = ref(false);

//投稿ボタンのロック
const lockSubmit = ref(false);

//指定された DOM の祖先中から、指定されたクラスを持っているものを返す
const _findParent = (className, child) => {
  //自身が null, または undefined なら null を返す
  if (child === null || child === undefined) {
    return null;
  }

  //自身がクラスを持っていたら返す
  if (child.classList.contains(className)) {
    return child;
  }

  //自身が html 要素なら null　を返す
  if (child instanceof HTMLHtmlElement) {
    return null;
  }

  //そうでなければ親を検索
  return _findParent(className, child.parentElement);
};

//スクロール禁止用関数
const _noscroll = event => {
  //親に js-modalScroll があればスクロールを許可
  if (_findParent('js-modalScroll', event.target)) {
    return;
  }

  //スクロールの禁止
  event.preventDefault();
}

//表示する
const openModal = () => {
  //非表示時に対応するため、scrollTop を保存
  scrollTop.value = window.scrollY;

  //スクロールバーの幅を用意
  const scrollbarWidth = window.innerWidth - document.body.clientWidth;

  //スクロールバーの幅が取れたら
  setTimeout(() => {
    //body のスクロールを禁止する
    document.body.style.left = '0';
    document.body.style.right = scrollbarWidth+'px';
    document.body.style.top = String(scrollTop.value * -1)+'px';
    document.body.style.position = 'fixed';

    //モーダルを表示
    showModal.value = true;
  }, 150);
};

//非表示にする
const closeModal = () => {
  //body のスクロール禁止を解除する
  document.body.style.position = 'static';
  window.scrollTo(0, scrollTop.value);

  //モーダルを非表示
  showModal.value = false;

  //確認モードも解除
  isConfirm.value = false;

  //body のスクロールを解放
  document.body.removeEventListener('touchmove', _noscroll);
  document.body.removeEventListener('wheel', _noscroll);
};

//ニックネーム表示・非表示をトグルさせる
const toggleNicknameSelect = () => {
  showNicknameSelect.value = ! showNicknameSelect.value;
};

//ウィンドウの表示イベントを監視
window.addEventListener('showPost', () => {
  //モーダルを表示
  openModal();

  //body のスクロールを抑制
  document.body.addEventListener('touchmove', _noscroll, {passive: false});
  document.body.addEventListener('wheel', _noscroll, {passive: false});
});

//ウィンドウの投稿内容復旧イベントを監視
window.addEventListener('restoreEvent', () => {
  composition.restore(Number(window.restorePostId));
});

//ニックネーム追加欄を開く
const openAppendNickname = () => {
  //セレクトボックスを閉じる
  showNicknameSelect.value = false;

  //フォームを表示
  showNicknameAppend.value = true

  //フォーカスを当てる
  setTimeout(() => {
    if (document.getElementById('appendNickname')) {
      document.getElementById('appendNickname').focus();
    }
  }, 300);
};

//ニックネーム追加欄を閉じる
const closeAppendNickname = () => {
  setTimeout(() => {
    showNicknameAppend.value = false;
  }, 300);
};

//ニックネーム新規追加エリアを表示
const appendNickname = async () => {
  //現在のタイムスタンプを得る
  const now = (new Date()).getTime();

  //まだ 2 秒以上経っていない
  if (now - showNicknameAppendTimer.value <2000) {
    return;
  }

  //タイマー更新
  showNicknameAppendTimer.value = now;

  //もしセレクトボックスが開いていたら閉じる
  showNicknameSelect.value = false;

  //エラーを初期化
  nicknameAppendErrors.value = [];

  //ニックネームの追加を試みる
  const result = await composition.appendNickname(nicknameAppend.value);

  //成功したらニックネーム入力欄を空にし、追加されたニックネームを選択済みにする
  if (typeof result ==='number') {
    setTimeout(() => {
      //ニックネーム欄を空にする
      nicknameAppend.value = '';

      //入力モードの終了
      showNicknameAppend.value = false;

      //ニックネームを選択済にする
      composition.state.nicknameId = result;
    }, 300);
  }

  //失敗したらエラーメッセージを表示
  else if (Array.isArray(result)) {
    nicknameAppendErrors.value = result;
  }
};

//現在の入力内容を下書きとして保存する
const draft = async () => {
  //結果を得る
  const result = await composition.post(true)

  //成功した場合はマイページに移動
  if (result) {
    window.location.href = siteUrl+'mypage/post';
  }
};

//確認フェーズへ進む
const confirm = () => {
  // campaignLimit が true なら何もしない
  if (composition.state.campaignLimit) {
    return;
  }

  //この setTimeout の意味は、
  //1. ボタンクリックと同時に DOM の構造が変わる
  //2. DOM の構造変更により祖先要素が中途半端に追えなくなる
  //3. closeModalBack() 内で、祖先に js-modalInner が存在しないことになる
  //4. ボタンは js-modalInner の中にあるにもかかわらず、モーダルが閉じてしまう
  //という現象を回避するため
  setTimeout(() => {
    //確認モードにする
    isConfirm.value = true;
  }, 100)
};

//確認画面から前へ戻る
const back = () => {
  //この setTimeout の意味は、
  //1. ボタンクリックと同時に DOM の構造が変わる
  //2. DOM の構造変更により祖先要素が中途半端に追えなくなる
  //3. closeModalBack() 内で、祖先に js-modalInner が存在しないことになる
  //4. ボタンは js-modalInner の中にあるにもかかわらず、モーダルが閉じてしまう
  //という現象を回避するため
  setTimeout(() => {
    isConfirm.value = false;
  }, 100);
};

//実際に投稿する
const submit = async () => {
  //ロック中だったら何もしない
  if (lockSubmit.value) {
    return;
  }

  //一時ロック
  lockSubmit.value = true;

  //ロックを 10 秒後に解除
  setTimeout(() => {
    lockSubmit.value = false;
  }, 10000);

  //投稿実行
  const result = await composition.post();

  //成功した場合はモーダルを閉じる
  if (result) {
    closeModal();
  }
};

//DOM の描写が終わったら起動
onMounted(async () => {
  //タグキャンペーンであればタグキャンペーン設定を仕込む
  if (campaignTagId && Number(campaignTagId) !== 0) {
    //ID を保持
    composition.state.campaignTagId = Number(campaignTagId);

    //キャンペーンカテゴリ/タグの名称を保持
    _campaignTagCategoryName.value = campaignTagCategoryName;
    _campaignTagTagName.value = campaignTagName;

    //感情を 1 にしておく
    composition.state.emotion = 1;
  }

  //情報更新を行う
  await composition.init();

  //post.js を始動させる
  window.dispatchEvent(new Event('vueReadyInit'));

  // 疑似セレクトボックス外の要素をクリックした際、疑似セレクトボックスを非表示にする、
  document.addEventListener('click', (event) => {
    if ( ! event.target.closest('.modSelectTrigger')) {
      showNicknameSelect.value = false;
    }
  });
});
</script>

<template>
  <div :class="{modModalWindow: true, isShow: showModal}">
    <div class="modModalTitleContainer">
      <p class="pFont16 pFontBold">投稿フォーム</p>
      <button
        type="button"
        class="lyHvCnt lyColumn lyW48px lyH48px pFont10 pFontBold"
        @click="closeModal"
      >
    <span class="lyBlock lyW24px"><img
      :src="siteUrl+'images/iconClose.svg'"
      loading="lazy"
      alt="" width="30"
      height="31"
    ></span>
        とじる
      </button>
    </div>
    <div class="modModalBottomWrapper js-modalScroll">
      <div class="lyPd8 lyTbPl16 lyTbPr16">
        <p
          v-if="Number(composition.state.campaignTagId) === 0"
          class="lyMb16 pFont10 pTbFont12 pFontMedium pFontGray30"
        >質問の場合は回答募集ボタンをタップすると回答が得られやすくなるよ。</p>
        <label
          v-if="Number(composition.state.campaignTagId) === 0"
          class="lyInlineBlock lyMb16 modEllipseChip dPink"
        >
          <input
            v-model="composition.state.isAnswersWanted"
            type="checkbox"
          >
          <span class="lyInlineBlock lyPt6 lyPb6 lyPr8 lyPl8 pFont14 pFontBold pFontWhite pBackColorGray30 pBorderRadiusEllipse pHoverOpacityDefault modEllipseChipBtn">回答募集</span>
        </label>
        <label
          v-else
          class="lyInlineBlock lyMb16 modEllipseChip dYellow"
        >
          <input
            type="checkbox"
            checked
            readonly
          >
          <span class="lyInlineBlock lyPt6 lyPb6 lyPr8 lyPl8 pFont14 pFontBold pFontWhite pBackColorGray30 pBorderRadiusEllipse pHoverOpacityDefault modEllipseChipBtn">キャンペーン</span>
        </label>
        <p
          v-if="composition.state.campaignLimit"
          class="lyMb8 pFont12 pFontMedium pFontRed"
        >この#タグキャンペーンへ既に1回投稿済なので投稿できません。</p>
        <div class="lyMb4">
          <div :class="{modSelectTrigger: true, isShow: showNicknameSelect}">
            <p
              v-if="showNicknameAppend"
              class="pErrTxt"
            >
              <template
                v-for="(error, index) in nicknameAppendErrors"
              >
                <br v-if="index !== 0">
                {{error}}
              </template>
            </p>
            <form
              v-if="showNicknameAppend"
              class="modPostInputNoName lyHorizontal"
              @submit.prevent="appendNickname"
            >
              <input
                v-model="nicknameAppend"
                type="text"
                id="appendNickname"
                class="lyW100 lyPt16 lyPb16 lyPl8 lyPr8 pBackColorWhite pBorderRadius2px lyTextLeft"
                @keyup.enter="appendNickname"
                @focus="showNicknameSelect = false"
                @input="showNicknameSelect = false"
              >
              <button
                v-show="nicknameAppend !== ''"
                style="white-space:nowrap;margin:0 16px;padding:4px 8px;top:15px;right:55px;color:#66cc66;border:1px solid #66cc66;background-color:#fff;"
                type="button"
                class="modModalClose pageTtralKokeNext"
                @click="appendNickname"
              >登録</button>
              <button
                type="button"
                class="modModalClose"
                style="width:20px;margin:16px;"
                @click="closeAppendNickname"
              >
                      <span class="dIcon"><img
                        :src="siteUrl+'images/close.svg'"
                        alt="閉じる"
                      ></span>
              </button>
            </form>
            <button
              v-else-if="Number(composition.state.nicknameId) === -2"
              type="button"
              name="nickname"
              class="lyW100 lyPt16 lyPb16 lyPl8 lyPr8 pBackColorWhite pBorderRadius2px lyTextLeft"
              @click="toggleNicknameSelect"
            >ここをタップして投稿者名を選択</button>
            <button
              v-else
              :style="isConfirm ? 'pointer-events:none' : ''"
              type="button"
              name="nickname"
              class="lyW100 lyPt16 lyPb16 lyPl8 lyPr8 pBackColorWhite pBorderRadius2px lyTextLeft"
              @click="toggleNicknameSelect"
            >{{composition.nickname.value}}</button>
            <div class="modSelectListContainer modSelectListContainerPc">
              <ul class="modSelectList">
                <li
                  v-for="(nickname) in composition.state.nicknames"
                  :key="nickname.id"
                  class="pBorderBottom1pxSolidGray4"
                >
                  <button
                    type="button"
                    class="lyW100 lyPt12 lyPb12 lyPr8 lyPl8 lyTextCnt pFontBold pHoverBackGray4 pAnimation"
                    @click="composition.state.nicknameId = nickname.id, toggleNicknameSelect()"
                  >{{nickname.name}}</button>
                </li>
                <li
                  v-if="composition.state.nicknames.length < 7"
                  class="pBorderBottom1pxSolidGray4"
                >
                  <button
                    type="button"
                    class="lyW100 lyPt12 lyPb12 lyPr8 lyPl8 lyTextCnt pFontBold pHoverBackGray4 pAnimation"
                    @click="openAppendNickname(), toggleNicknameSelect()"
                  ><span class="modPostInputNickName">新規追加</span></button>
                </li>
              </ul>
            </div>
            <teleport to="body">
              <div
                :class="{gbModalBack: true, gbTriggerModalBack: true, isShow: showNicknameSelect}"
                style="z-index: 302"
              ></div>
              <div :class="{modSelectListContainer: true, modSelectListContainerSp: true, isShow: showNicknameSelect}">
                <ul class="modSelectList js-modalScroll">
                  <li
                    v-for="(nickname) in composition.state.nicknames"
                    :key="nickname.id"
                    class="pBorderBottom1pxSolidGray4"
                  >
                    <button
                      type="button"
                      class="lyW100 lyPt12 lyPb12 lyPr8 lyPl8 lyTextCnt pFontBold pHoverBackGray4 pAnimation"
                      @click="composition.state.nicknameId = nickname.id, toggleNicknameSelect()"
                    >{{nickname.name}}</button>
                  </li>
                  <li
                    v-if="composition.state.nicknames.length < 7"
                    class="pBorderBottom1pxSolidGray4"
                  >
                    <button
                      type="button"
                      class="lyW100 lyPt12 lyPb12 lyPr8 lyPl8 lyTextCnt pFontBold pHoverBackGray4 pAnimation"
                      @click="openAppendNickname(), toggleNicknameSelect()"
                    ><span class="modPostInputNickName">新規追加</span></button>
                  </li>
                </ul>
              </div>
            </teleport>
          </div>
        </div>
        <div class="lyMb4">
          <input
            v-model="composition.state.title"
            :readonly="isConfirm"
            type="text"
            name="nickname"
            placeholder="件名を入力してください。"
            class="lyW100 lyPt12 lyPb12 lyPl8 lyPr8 pBackColorWhite pBorderRadius2px"
          >
        </div>
        <div>
          <div class="lyOverFlewHidden pBorderRadius2px">
            <textarea
              v-model="composition.state.content"
              :readonly="isConfirm"
              class="lyW100 lyPd8 pBackColorWhite"
              placeholder="投稿内容"
              rows="10"
            ></textarea>
            <div class="lyPd8 pBackColorWhite">
              <div class="lyHorizontal pFont10">
                <div :class="{lyHorizontal: true, pFontRed: ! composition.isContentLength.value, pFontGreen: composition.isContentLength.value}">
                  <p class="lyMr4">現在</p>
                  <p class="lyMr4">{{new Intl.NumberFormat().format(composition.contentLength.value)}}</p>
                  <p class="lyMr4">文字入力</p>
                </div>
                <p class="pFontGray30">※最大1000文字入力可能</p>
              </div>
              <p
                v-if="isConfirm && Number(composition.state.campaignTagId) !== 0"
                class="lyHorizontal lyMt8"
              >
                <span class="lyVerticalCnt lyPd8 pFont12 pFontBold pFontBlack pBackColorGray4 pBorderRadius2px">{{_campaignTagCategoryName}}<span class="lyMl2">#{{_campaignTagTagName}}</span></span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="isConfirm"
        class="lyPd8 lyTbPl16 lyTbPr16"
      >
        <div
          v-show="Number(composition.state.campaignTagId) === 0"
          class="lyPd8 lyMb4 pBackColorWhite pBorderRadius2px"
        >
          <p class="lyVerticalCntBreak lyMb12 pFont14 pFontBold">
            カテゴリ選択
            <span class="lyPd4 lyMl8 pFont10 pFontBold pBackColorGray4 pBorderRadius2px">任意</span>
          </p>
          <p class="pFont10 lyMb10">※カテゴリーを選択すると共感やコメントがもらいやすくなるよ！</p>
          <ul class="lyHorizontalBreak">
            <li
              v-for="category in composition.state.categories"
              :key="category.id"
              class="lyMr8 lyMt8 lyMb8"
            >
              <label class="lyInlineBlock modEllipseChip dGreen">
                <input
                  v-model="composition.state.categoryIds"
                  :value="category.id"
                  type="checkbox"
                >
                <span class="lyInlineBlock lyPt4 lyPb4 lyPr8 lyPl8 pFont14 pFontBold pFontWhite pBackColorGray30 pBorderRadiusEllipse pHoverOpacityDefault modEllipseChipBtn">{{category.name}}</span>
              </label>
            </li>
          </ul>
        </div>
        <div class="lyPd8 lyMb4 pBackColorWhite pBorderRadius2px">
          <p class="pFont10 lyMb10">※コメントがいらない場合はここで設定できます。</p>
          <div class="lyHorizontalBw">
            <p class="pFont12 pFontBold">みんなからのコメント</p>
            <label
              :for="uniqueIdPrefix+'cmntRcpt'"
              class="pSwitch lyVerticalCnt"
            >
              <input
                v-model="composition.state.acceptComments"
                :true-value="true"
                :false-value="false"
                :id="uniqueIdPrefix+'cmntRcpt'"
                type="checkbox"
              >
              <div class="lyOrder1 pSwitchBtn"></div>
              <p class="lyOrder0 lyMr4 pSwitchTitle pFont12 pFontBold">ほしい</p>
              <p class="lyOrder2 lyMl4 pSwitchTitle pFont12 pFontBold">いらない</p>
            </label>
          </div>
        </div>
      </div>
      <div v-if="Object.keys(composition.errorLines.value).length !== 0">
        <p
          v-for="(message) in composition.errorLines.value"
          class="lyMb8 pFont12 pFontMedium pFontRed lyHidden"
        >{{message}}</p>
      </div>
      <div
        v-if="Object.keys(composition.errorLines.value).length !== 0"
      >
        <p
          v-for="(message) in composition.errorLines.value"
          class="lyMb8 pFont12 pFontMedium pFontRed lyHidden"
        >{{message}}</p>
      </div>
      <div class="lyPd8 lyHorizontalBw">
        <p class="lyPr4 lyW50">
          <button
            v-if=" ! isConfirm"
            type="submit"
            class="lyHvCnt lyW100 lyPt12 lyPb12 lyTextCnt pFont14 pFontBold pFontGreen pBackColorGray4 pBorder1pxSolidGreen pBorderRadius2px"
            @click="draft"
          >下書き保存</button>
          <button
            v-else
            type="button"
            class="lyHvCnt lyW100 lyPt12 lyPb12 lyTextCnt pFont14 pFontBold pFontGreen pBackColorGray4 pBorder1pxSolidGreen pBorderRadius2px"
            @click="back"
          >戻って編集</button>
        </p>
        <p class="lyPl4 lyW50">
          <button
            v-if=" ! isConfirm"
            :class="{lyHvCnt: true, lyW100: true, lyPt12: true, lyPb12: true, lyTextCnt: true, pFont14: true, pFontBold: true, pFontWhite: true, pBackColorGreen: true, pBorderRadius2px: true, pHoverSlideChange: true, isDisabled: ! composition.isEditComplete.value || composition.state.campaignLimit}"
            type="button"
            @click="confirm"
          >確認する</button>
          <button
            v-else
            :disabled="lockSubmit"
            :class="{lyHvCnt: true, lyW100: true, lyPt12: true, lyPb12: true, lyTextCnt: true, pFont14: true, pFontBold: true, pFontWhite: true, pBackColorGreen: true, pBorderRadius2px: true, pHoverSlideChange: true, isDisabled: lockSubmit}"
            type="button"
            @click="submit"
          >投稿する</button>
        </p>
      </div>
    </div>
    <teleport to="body">
      <div
        v-if="showModal"
        :class="{gbModalBack: true, isShow: showModal}"
        @click="closeModal"
      ></div>
    </teleport>
  </div>
</template>
